var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("聯絡資訊")]),
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              _vm.dialog = true
              _vm.select = null
            },
          },
        },
        [_vm._v("新增聯絡人")]
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.profiles, stripe: "" },
        },
        [
          _c("el-table-column", { attrs: { prop: "name", label: "名稱" } }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "備註" },
          }),
          _c("el-table-column", { attrs: { prop: "address", label: "地址" } }),
          _c("el-table-column", { attrs: { prop: "phone", label: "電話" } }),
          _c("el-table-column", { attrs: { prop: "email", label: "email" } }),
          _c("el-table-column", {
            attrs: { label: "動作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            _vm.dialog = true
                            _vm.select = scope.row
                          },
                        },
                      },
                      [_vm._v("編輯")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialog, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialog = $event
            },
          },
        },
        [
          _vm.dialog
            ? _c("pform", {
                attrs: {
                  profile_id: _vm.company_id,
                  profile_type: "company",
                  profile: _vm.select,
                },
                on: { onUpdate: _vm.onUpdate },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }